import { Box } from '@mantine/core';
import { memo } from 'react';
import { Link } from 'react-router-dom';

import styles from './styles.module.css';

export const FooterLinks = memo(() => (
  <Box className={styles.footer}>
    <Link className={styles.footerLink} to="/">
      Contact Us
    </Link>
    <Link className={styles.footerLink} to="/">
      Terms and Conditions
    </Link>
    <Link className={styles.footerLink} to="/">
      Privacy Policy
    </Link>
  </Box>
));
